import gql from 'graphql-tag';

import { DRIVER_MY_DAY_DOCKET_FRAGMENT } from '../myDay/driverMyDayQueries';

// Optional pagination: history is paged, while the two-day window loads every
// assigned run so a second unfinished run cannot unlock tomorrow's preview.
export const GET_MY_RUNS = gql`
	query MyRuns($page: Int, $perPage: Int, $filter: ServiceRunPageFilter) {
		getServiceRuns(page: $page, perPage: $perPage, sortBy: "planned", sortDirection: -1, filter: $filter) {
			items {
				id
				planned
				route { id name }
				vehicle { id name registration }
				serviceDockets {
					id
					status
					inventoryCheck
					isRestocked
					machineServiceType
					driverTicketCount
					ticketsResolved
					requirePhoto
					photoTaken
					couldNotComplete { at }
					ticketList { id }
					machine { id isOffline usesIngredients commDevices { id } }
				}
			}
			count
		}
	}
`;

export const GET_MY_RUN_OVERVIEW = gql`
	query MyRunOverview($filter: ServiceRunPageFilter) {
		getServiceRuns(sortBy: "planned", sortDirection: -1, filter: $filter) {
			items {
				id
				planned
				brief
				route { id name }
				vehicle { id name registration }
				driver { id firstname lastname username }
				warehouse { id name }
				returnWarehouse { id name }
				startLocation { id name }
				endLocation { id name }
				serviceDockets { ...driverMyDayDocket }
			}
		}
	}
	${DRIVER_MY_DAY_DOCKET_FRAGMENT}
`;
